import { gql } from '@efficiently/client-core-graphql-models';

export const UPDATE_PROJECT_DESIGN_CHANGE = gql(`
	mutation UpdateProjectDesignChange($_id: ID!, $input: UpdateProjectDesignChangeInput!) {
		updateProjectDesignChange(_id: $_id, input: $input) {
			...ProjectDesignChangeDetail
		}
	}
`);
